import { nextStateHistory, StateHistory } from 'aurelia-store';
import cloneDeep from 'lodash-es/cloneDeep';

import { AppState, initialState, STATE_LOCAL_STORAGE_KEY } from '~/app-store';
import { getItem } from '~/utils/local-storage';

// Reset state but keep bookmarks, history, and searchHistory
const ResetState = (
	stateHistory: StateHistory<AppState>,
	override?: AppState,
	resetNavigation?: boolean,
) =>
	nextStateHistory<AppState>(
		stateHistory,
		cloneDeep({
			...initialState,
			navigation: {
				...initialState.navigation,
				bookmarks: resetNavigation
					? initialState.navigation.bookmarks
					: stateHistory.present.navigation.bookmarks,
				history: resetNavigation
					? initialState.navigation.history
					: stateHistory.present.navigation.history,
				searchHistory: resetNavigation
					? initialState.navigation.searchHistory
					: stateHistory.present.navigation.searchHistory,
			},
			...override,
		}),
	);

const LoadStateFromLocalStorage = (stateHistory: StateHistory<AppState>) => {
	const localState = getItem(STATE_LOCAL_STORAGE_KEY);
	if (localState) {
		return nextStateHistory<AppState>(
			stateHistory,
			JSON.parse(localState) as AppState,
		);
	}
	return ResetState(stateHistory);
};

export const AppActions = {
	LoadStateFromLocalStorage,
	ResetState,
};
